var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSql(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sql data base with logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n#black {\r\n  fill:#333;\r\n}\r\n@media (prefers-color-scheme:dark) {\r\n    #black {\r\n        fill: white;\r\n    }\r\n} \t\r\n"))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 50,
    ry: 35,
    rx: 85,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35,50 v150  a 85,35 1 1 0 170,0 v-150 m-170,50  a 85,35 1 1 0 170,0 m-170,50 a 85,35 1 1 0 170,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 15
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 15
    },
    d: "m300,100 a 25,25 1 1 0 -50,0 a 20,25 1 0 0 25,25 a 20,25 1 0 1 20,25 a 25,25 1 0 1 -50,-5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 15
    },
    d: "m375,175 a 50,50 1 1 1 15,-5 m-15,-20 l30,40 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 15
    },
    d: "m440,70 v80  a 25,25 1 0 0 25,25 h20 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSql);
export default __webpack_public_path__ + "static/media/Sql.b26e31caf334a281cb3fb42126d5c836.svg";
export { ForwardRef as ReactComponent };